import { action, makeObservable, observable } from "mobx";
import PlacesApi, { PlacesApi as IPlacesApi } from "../../../../../../../../services/api/v2/places/Places.api";
import ModalContext from "../../../../../../../modalZ/context/ModalContext";
import { IModalContextModel } from "../../../../../../../modalZ/context/IModalContext";
import ImpactsApi, { ImpactsApi as IImpactsApi } from "../../../../../../../../services/api/v2/impacts/Impacts.api";
import { GridApi } from "ag-grid-community";
import { AppGridState } from "../../../base/AppGrid_view";
import { IPlacesSummary } from "../../../placeGroupsGrid/modals/AddPlacesGridModal/AddPlaces_model";

export class ImpactPlacesLinkModalModel {
  organisationId: number;
  projectId: number;
  placesProvider: IPlacesApi;
  @observable places: any[];
  placeId: number;
  impactId: number;
  impactsProvider: IImpactsApi;
  modalService: IModalContextModel;
  @observable selectedItems: number[] = [];
  //   @observable preSelectedItemIds: number[];
  gridApi: GridApi;

  @observable isLoading: boolean = true;
  @observable placesColDefs: any[] = [];
  itemIds: number[];

  constructor(organisationId: number, projectId: number, ids: number[], placeId: number, impactId: number) {
    makeObservable(this);
    this.organisationId = organisationId;
    this.projectId = projectId;
    this.placesProvider = PlacesApi;
    this.placeId = placeId;
    this.modalService = ModalContext;
    this.itemIds = ids;
    this.impactsProvider = ImpactsApi;
    this.impactId = impactId;
  }

  onMount = async () => {
    await this.showAllPlaces();
  };

  onUnmount = () => {};

  @action
  onGridStateUpdate = (gridState: AppGridState) => {
    this.gridApi = gridState.gridApi;
    this.selectedItems = gridState.selectedItems || [];
  };

  showAllPlaces = async () => {
    let res = await this.placesProvider.getAllPlaces(this.organisationId);
    if (!res || res.isError) return;
    const payload = res.payload;
    this.setPlaces(this.mapToPlacesSummary(payload));
    this.isLoading = false;
  };

  @action
  setPlaces = (places: IPlacesSummary[]) => {
    this.places = places;
  };

  mapToPlacesSummary = (data: FP.Entities.IPlaceDetail[]): IPlacesSummary[] => {
    return data.map(e => {
      return {
        id: (e as any).id,
        name: e.name,
        streetAddress: e.streetAddress,
        city: e.city,
        country: e.country,
        latitude: e.latitude,
        longitude: e.longitude
      } as IPlacesSummary;
    });
  };

  @action
  setPlacesColDefs = (placesColDefs: any[]) => {
    this.placesColDefs = placesColDefs;
  };

  assignPlacesToImpacts = async placeIds => {
    await this.impactsProvider.addPlaces(this.organisationId, this.projectId, this.itemIds, placeIds);
    this.modalService.hide();
  };
}
